import React from "react";
import "./CompanyOverview.css"; // Reusing the same card layout CSS
import { Helmet } from "react-helmet-async";
const TermsAndConditions = () => {
    return (
        <div className="company-wrapper">

            <Helmet>
  <title>Terms & Conditions | APTech Solution</title>
  <meta 
    name="description" 
    content="Read the terms and conditions of APTech Solution regarding the use of our website, services, data usage, and user responsibilities." 
  />
</Helmet>

            <div className="company-card">
                <h1 className="main-heading">📄 Terms and Conditions</h1>
                <p><strong>Last Updated:</strong> 19 July 2025</p>

                <p>
                    Welcome to the official website of <strong>A.P Tech Solution</strong>,
                    accessible at{" "}
                    <a
                        href="https://www.aptechsolution.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        www.aptechsolution.com
                    </a>
                    . By using this website, you agree to comply with these Terms and Conditions.
                    If you do not agree with any part, please discontinue using our website immediately.
                </p>

                <h2>1. Company Information</h2>
                <p>
                    <strong>A.P Tech Solution</strong><br />
                   

                    57 Krishnavilla, Opp: ONGC Colony behind Nayra Petrol Pump  near D'Mart, Ankleshwar, Gujarat 393001<br />
                    Email:{" "}
                    <a href="mailto:info@aptechsolution.com">info@aptechsolution.com</a>
                </p>

                <h2>2. Acceptable Use</h2>
                <p>
                    By accessing this website, you agree not to engage in activities that may:
                </p>
                <ul>
                    <li>Violate any local, national, or international laws</li>
                    <li>Damage, disrupt, or impair the website’s functionality</li>
                    <li>Transmit harmful, offensive, or unlawful material</li>
                    <li>Copy or redistribute content without authorization</li>
                </ul>

                <h2>3. Intellectual Property Rights</h2>
                <p>
                    All logos, trademarks, text, graphics, and other content are owned by{" "}
                    <strong>A.P Tech Solution</strong> unless otherwise stated. You may
                    not reproduce, distribute, or exploit our materials without prior
                    written consent.
                </p>

                <h2>4. Services and Content</h2>
                <p>
                    We aim to provide accurate information about our software development,
                    IT consulting, and related services. However, we do not guarantee that
                    all details (including pricing and availability) will always be free of
                    errors or omissions.
                </p>

                <h2>5. Limitation of Liability</h2>
                <p>
                    A.P Tech Solution shall not be held responsible for any direct,
                    indirect, incidental, or consequential damages arising from your use
                    (or inability to use) this website or its services.
                </p>

                <h2>6. Third-Party Links</h2>
                <p>
                    Our website may contain links to third-party websites. We are not
                    responsible for their content, accuracy, or policies. Accessing
                    external links is at your own risk.
                </p>

                <h2>7. Privacy Policy</h2>
                <p>
                    Your use of this site is also governed by our{" "}
                    <a href="/privacy-policy">Privacy Policy</a>, which describes how we
                    handle your personal information.
                </p>

                <h2>8. Governing Law</h2>
                <p>
                    These Terms shall be governed by and construed in accordance with the
                    laws of India. Any disputes shall be subject to the exclusive
                    jurisdiction of the courts in New Delhi, India.
                </p>

                <h2>9. Modifications</h2>
                <p>
                    A.P Tech Solution reserves the right to revise these Terms at any
                    time. Updates will be posted on this page, and continued use of the
                    site indicates acceptance of any changes.
                </p>

                <h2>10. Contact Us</h2>
                <p>
                    For questions or concerns regarding these Terms, please contact us at:
                </p>
                <p>
                    📧{" "}
                    <a href="mailto:info@aptechsolution.com">info@aptechsolution.com</a>
                    <br />
                    📍 57 Krishnavilla, Opp: ONGC Colony behind Nayra Petrol Pump  near D'Mart, Ankleshwar, Gujarat 393001
                </p>
            </div>
        </div>
    );
};

export default TermsAndConditions;
